
  import {Component, Vue} from "vue-property-decorator";
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import Filters from "@/modules/CarList/components/Filters.vue";
  import TopControls from "@/modules/CarList/components/TopControls.vue";
  import CarList from "@/modules/CarList/components/CarList.vue";
  import BalanceButton from "@/modules/CarList/components/BalanceButton.vue";
  import CarListTable from "@/modules/CarList/components/CarListTable.vue";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import CarsUnion from "@/modules/CarList/components/carsUnion/CarsUnion.vue";
  import UploadCarsExcelPopup from "@/modules/CarList/components/UploadCarsExcelPopup.vue";
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      UploadCarsExcelPopup,
      AppPageHeader,
      Filters,
      TopControls,
      CarList,
      BalanceButton,
      CarListTable,
      CarsUnion,
    },
  })
  export default class PageCarList extends Vue {
    $refs: any;
    isLoading: boolean = true;
    listingDisplayModes = ICarList.ListingDisplayMode;

    get storeState(): IAppState { return this.$store.state; }
    get listingMode() { return this.storeState.carList.activeListingMode; }
    get displayFilters() { return this.storeState.carList.displayFilters; }
    get dialogs(): IDialogStoreState { return this.storeState.dialog; }

    async created() {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('carList/init');
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }

    clearActiveRow() {
      if (this.listingMode === this.listingDisplayModes.EnterTable)
        this.$refs.carUnionTable.activateRow(null);
    }

    destroyed() {
      this.$store.commit('carList/setProperty', { name: 'carList', value: [], })
    }
  }
